import moment from 'moment';

import {
  GUARANTEE_SERVICE_TYPE_CHOICES,
  SERVICE_TYPE_CHOICES,
} from '@rover/app/js/constants/serviceConstants';
import Backbone from '@rover/globals/backbone';
import $ from '@rover/globals/jquery';
import Mustache from '@rover/globals/Mustache';
import Rover from '@rover/globals/Rover';
import _ from '@rover/globals/underscore';
import { mount as mountEmergencyForm } from '@rover/react-lib/pages/conversations/EmergencyFormPage';
// WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'
import DF from '@rover/shared/js/constants/i18n/datetime/datetimeInjected';
import { redirect } from '@rover/utilities/url';

export default Backbone.View.extend({
  template: Mustache.template('new_design/account_conversations/confirmation'),
  initialize(options) {
    this.requestableModel = options.requestableModel;
    this.relationshipModel = options.relationshipModel;
    this.showCallback = options.showCallback;
  },
  addPaymentCompletedHashForReactNative() {
    location.hash = 'payment-completed';
  },
  render() {
    const data = this.requestableModel.toJSON();
    const state = this.requestableModel.getState();

    this.addPaymentCompletedHashForReactNative();

    data.isSitter = Rover.context.isSitter;
    data.isMobileEmbedded = Rover.context.isMobileEmbedded;

    if (this.requestableModel.isRecurring) {
      data.stay_meta = this.requestableModel.getActiveConversation().attributes.stay_meta;
    }

    data.cancellation_policy_name = Rover.context.cancellationPolicyName;
    data.cancellation_policy_desc = Rover.context.cancellationPolicyDesc;

    if (state === 'booked') {
      data.booked = true;
    } else if (state === 'requested') {
      if (data.isSitter) {
        // Sitters need to accept back on the conversation page
        redirect(data.web_url);
      }
      data.requested = true;
    }

    if (data.pets && data.pets.length) {
      data.multiplePets = data.pets && data.pets.length > 1;

      data.dogs = Rover.utils.simpleSyndeticJoin(_.map(data.pets, (dog) => dog.name));

      data.pets = data.pets.map((pet) => {
        const newInfo = {};
        newInfo.urls = Rover.urls.petEditURLs[pet.url];
        if (pet.care_instructions) {
          newInfo.care_instructions = pet.care_instructions;
        }
        return { ...pet, ...newInfo };
      });
    }

    if (data.pets && data.pets.length) {
      data.emergency_contact_information =
        data.pets[0].emergency_contact_information || '[None entered]';

      if (data.pets[0].urls) {
        data.editEmergencyContactUrl = data.pets[0].urls.editEmergencyContact;
      }
    }

    _.each(['start_date', 'end_date'], (prop) => {
      data[`${prop}_formatted`] = moment(data[prop]).format(DF.MONTH_DAY_SHORT);
    });

    if (data.service_type === SERVICE_TYPE_CHOICES.boarding) {
      data.overnight = true;
    } else if (data.service_type === SERVICE_TYPE_CHOICES.traveling) {
      data.traveling = true;
    }

    data.showfaq = GUARANTEE_SERVICE_TYPE_CHOICES.includes(data.service_type);

    data.relationship = this.relationshipModel.toJSON();
    data.accountPaymentsURL = Rover.urls.accountPayments;
    data.guaranteeURL = Rover.urls.guarantee;

    this.$el.html(this.template.render(data));

    if ($('.js-payment-methods').is(':visible')) {
      $('.js-payment-methods').fadeOut('fast', () => {
        this.$el.fadeIn('fast');
        if ($.isFunction(this.showCallback)) {
          this.showCallback();
        }
      });
    } else {
      this.$el.show();
      if ($.isFunction(this.showCallback)) {
        this.showCallback();
      }
    }

    this.$('[data-toggle="popover"]').popover();

    if ($('#js-emergency-form').length) {
      const appProps = {
        showfaq: data.showfaq,
        conversationUrl: data.web_url,
        pets: data.pets,
      };

      mountEmergencyForm(appProps);
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/confirmation_view.js